import React from 'react'
import { Field, Form, Formik } from 'formik'
import { Button, Grid } from '@material-ui/core'
import { TextField } from 'formik-material-ui'
import { metodoPrograma } from '../../../components/api'

export const Cadastro = ({ objeto, voltar }) => {
  const initialValues = {
    idEmpresa: objeto?.[0] || undefined,
    nmEmpresa: objeto?.[1] || undefined,
    dtInclusao: objeto?.[2] || undefined,
    dtExclusao: objeto?.[3] || undefined,
  }

  const salva = async (values) => {
    const res = await metodoPrograma('salva', values)
    if (res.status) voltar()
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Field
                component={TextField}
                name="nmEmpresa"
                label="Nome da empresa"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={2}>
              <Field
                component={TextField}
                name="dtInclusao"
                label="Inclusao"
                disabled
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={2}>
              <Field
                component={TextField}
                name="dtExclusao"
                label="Exclusão"
                disabled
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}
